export default __webpack_public_path__ + "static/Codcluster-6e567487fd9e04329ec6ced3abd1e3f4.png";